import { Account } from '@/types/models/Account'
import apiRequest from '../api'
import {
  CreateAccountDTO,
  UpdateAccountDTO,
  UpdateAccountEntitlementsDTO,
} from './account.dto'

const prefix = 'accounts'

export const accountRoutes = {
  list: `${prefix}/`,
  create: `${prefix}/`,
  get: (id: number) => `${prefix}/${id}`,
  update: (id: number) => `${prefix}/${id}`,
  updateEntitlements: (id: number) => `${prefix}/${id}/entitlements`,
  uploadLogo: (id: number) => `${prefix}/${id}/logo`,
  getBillingMetrics: (id: number) => `${prefix}/${id}/billing-metrics`,
  getMissionsMetrics: (id: number) => `${prefix}/${id}/missions-metrics`,
  getStorage: (id: number) => `${prefix}/${id}/storage`,
  delete: (id: number) => `${prefix}/${id}`,
}

export const createAccountRequest = (data: CreateAccountDTO) =>
  apiRequest<Account>(accountRoutes.create, {
    method: 'POST',
    data,
  })

export const updateAccountRequest = (id: number, data: UpdateAccountDTO) =>
  apiRequest<void>(accountRoutes.update(id), {
    method: 'PUT',
    data,
  })

export const deleteAccountRequest = (id: number) =>
  apiRequest<void>(accountRoutes.delete(id), {
    method: 'DELETE',
  })

export const uploadLogoRequest = (id: number, data: FormData) =>
  apiRequest<void>(accountRoutes.uploadLogo(id), {
    method: 'POST',
    data,
  })

export const deleteLogoRequest = (id: number) =>
  apiRequest<void>(accountRoutes.uploadLogo(id), {
    method: 'DELETE',
  })

// S3.8 M2 — GOD-only entitlements toggle. Server returns the updated
// Account with the new entitlementsVersion. Side effect: every active
// session on the Account 401s on next request (S3.2 M0 freshness check).
export const updateAccountEntitlementsRequest = (
  id: number,
  data: UpdateAccountEntitlementsDTO,
) =>
  apiRequest<Account>(accountRoutes.updateEntitlements(id), {
    method: 'PUT',
    data,
  })
